module.exports = __webpack_public_path__ + "static/media/CMIC.94a502b4.JPG";